import '.fl{width:616px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.d2{gap:8px;}.ssr-plugin'
import '.f6{padding:8px;}.ssr-plugin'
import '.k{padding-bottom:16px;}.ssr-plugin'
import '.ge{padding:0 8px;}.ssr-plugin'
import '.he{height:36px;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.bu{padding-left:8px;}.ssr-plugin'
import '.fm{padding-right:8px;}.ssr-plugin'
import { useEffect, useMemo, useState } from 'react'
import { Sheet } from '../Sheet/index.js'
import { Button } from '../Button/index.js'
import { Text } from '../Text/index.js'
import { SelectInput } from '../SelectInput/index.js'
import { capitalize } from '../../utils/text.js'
import { styled } from 'inlines'
import { colors } from '../../tokens/colors.js'
import { IconButton } from '../IconButton/index.js'
import { getPropType, SchemaAnyProp } from '@based/sdk/schema'
import { UiSchemaType } from '../../types/schema.js'
import { radius } from '../../utils/radius.js'

export type SortInputProps = {
  columns: UiSchemaType[]
  sort?: Sort
  onChange: (value: Sort) => void
  disabled?: boolean
}

export type Sort = { key: string; direction: 'asc' | 'desc' }

export const SortInput = ({
  columns,
  sort: sortProp,
  onChange,
  disabled,
}: SortInputProps) => {
  const [sort, setSort] = useState<Sort>(sortProp)

  useEffect(() => {
    setSort(sortProp)
  }, [sortProp])

  return (
    <Sheet>
      <Sheet.Trigger>
        <IconButton
          disabled={disabled}
          icon="opposing-arrows-vertical"
          // counter={sort?.key ? 1 : undefined}
          onClick={() => {
            if (sort?.key && sort?.direction) {
              return
            }

            setSort({
              key: columns[0].key,
              direction: 'asc',
            })
            onChange({
              key: columns[0].key,
              direction: 'asc',
            })
          }}
        />
      </Sheet.Trigger>
      <Sheet.Content>
        <div className="fl a i d2 f6 k"
          style={{
            background: `linear-gradient(${colors.neutral10Background}),
                      linear-gradient(${colors.neutralInverted100})`,
            border: `1px solid ${colors.neutral10}`,
            borderRadius: radius[20],
          }}
        >
          <div className="a ge he d"
          >
            <Text variant="subtext-medium" color="neutral60">
              Sort items by...
            </Text>
          </div>

          <SortItemInput
            columns={columns}
            sort={sort}
            onChange={(value) => {
              onChange?.(value)

              if (!value) {
                Sheet.Close()
              }
            }}
          />
        </div>
      </Sheet.Content>
    </Sheet>
  )
}

type SortItemInputProps = {
  columns: UiSchemaType[]
  sort: Sort
  onChange: (value: Sort) => void
}

const SortItemInput = ({ columns, sort, onChange }: SortItemInputProps) => {
  const columnsMemo = useMemo(() => {
    return columns.map(({ key }) => ({
      value: key,
      label: capitalize(key),
    }))
  }, [columns.length])

  const getOptionsByType = (type: string) => {
    switch (type) {
      case 'reference':
      case 'alias':
      case 'text':
      case 'string': {
        return [
          { value: 'asc', label: 'A to Z' },
          { value: 'desc', label: 'Z to A' },
        ]
      }

      case 'number': {
        return [
          { value: 'asc', label: '0 to 9' },
          { value: 'desc', label: '9 to 0' },
        ]
      }

      case 'boolean': {
        return [
          { value: 'asc', label: 'true first' },
          { value: 'desc', label: 'false first' },
        ]
      }

      case 'timestamp': {
        return [
          { value: 'asc', label: 'Earliest first' },
          { value: 'desc', label: 'Latest first' },
        ]
      }

      default: {
        return [
          { value: 'asc', label: 'A to Z' },
          { value: 'desc', label: 'Z to A' },
        ]
      }
    }
  }

  const getColumn = (column: string) =>
    columns.find(({ key }) => key === column)

  const [options, setOptions] = useState<any[]>(
    getOptionsByType(getPropType(getColumn(sort?.key).prop as SchemaAnyProp)),
  )

  if (!sort?.key || !sort?.direction) {
    return
  }

  return (
    <div className="f bu fm a d2 d"
    >
      <SelectInput
        unclearable
        value={sort.key}
        onChange={(value) => {
          if (!value) {
            return
          }

          setOptions(
            getOptionsByType(
              getPropType(getColumn(value as string).prop as SchemaAnyProp),
            ),
          )

          onChange({ ...sort, key: value as any })
        }}
        options={columnsMemo}
      />
      <SelectInput
        unclearable
        value={sort.direction}
        onChange={(direction) => {
          if (!direction) {
            return
          }

          onChange({ ...sort, direction: direction as any })
        }}
        options={options}
      />
      <IconButton
        icon="close"
        size="small"
        onClick={() => {
          onChange(undefined)
        }}
      />
    </div>
  )
}
